<template>
  <div class="pagina-bot-full">

    <div class="container-bot">
      
      <div class="header-acao">
        <button @click="fecharBot" class="btn-fechar">
          Fechar
        </button>
      </div>

      <div class="iframe-wrapper">
        <iframe 
          src='https://interfaces.zapier.com/embed/chatbot/cmjh7y4zw005383m940tyk3f4' 
          height='650px' 
          width='100%' 
          allow='clipboard-write *' 
          style="border: none; background: white;"
        ></iframe>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "ZapierBot",
  methods: {
    fecharBot() {
      // MUDANÇA AQUI:
      // Em vez de mudar uma variável, nós mandamos o usuário para a rota inicial '/'
      // Se a sua home tiver outro link (ex: '/dashboard'), troque '/' pelo link correto.
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
/* CONTAINER */
.pagina-bot-full {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: sans-serif;
}

/* BOTÃO FECHAR (Vermelho) */
.header-acao {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-fechar {
  background-color: #dc3545; /* Vermelho */
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  transition: background 0.2s;
}
.btn-fechar:hover {
  background-color: #c82333;
}

/* IFRAME */
.iframe-wrapper {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}
</style>